// ABOUTME: Bridge to the native AuthSession plugin, which opens the OAuth URL in Safari on iOS.
// ABOUTME: Needed because itsme returns an https URL to the default browser, not to an in-app one.
import { registerPlugin } from '@capacitor/core';

export interface OpenInSystemBrowserOptions {
  /** Full authorization URL to open in the system browser. */
  url: string;
}

export interface AuthSessionPlugin {
  /**
   * Open the URL in Safari. Resolves once iOS accepts the request — the OAuth
   * callback arrives separately as an appUrlOpen event on the myabvv:// scheme.
   */
  openInSystemBrowser(options: OpenInSystemBrowserOptions): Promise<void>;
}

/**
 * Implemented natively on iOS only. On Android and web the call rejects as
 * unimplemented and AuthService falls back to the Capacitor Browser flow, which
 * works there: the itsme return re-enters the same Chrome Custom Tab.
 */
export const AuthSession = registerPlugin<AuthSessionPlugin>('AuthSession');

/**
 * True when the plugin is not available on this platform, so the caller should use
 * the Browser-based flow instead. Capacitor reports this as "UNIMPLEMENTED".
 */
export function isAuthSessionUnavailable(error: unknown): boolean {
  const code = (error as { code?: string })?.code;
  if (code === 'UNIMPLEMENTED' || code === 'UNAVAILABLE') {
    return true;
  }
  const message = (error as { message?: string })?.message ?? '';
  return /not implemented|unimplemented|not available/i.test(message);
}
